import axios from 'axios'
function requestInterceptors(config) {
  // console.log('--------3------------------------------------------', config);
  /** 如果有loading Loader,开启wait插件 */
  if (config && config.loadingLoader) {
    window.$wait.start(config.loadingLoader)
    return
  }
}
function responseInterceptors(config) {
  /** 清除该请求的loading载体 */
  if (config && config.loadingLoader) {
    window.$wait.end(config.loadingLoader)
    return
  }
}
axios.interceptors.request.use(
  config => {
    // let authorization = localStorage.getItem('authorization')
    // if (authorization) {
    //   config.headers.authorization = authorization
    // }
    requestInterceptors(config)
    return config
  },
  err => {
    responseInterceptors(err.config)
    return Promise.reject(err)
  }
)
axios.interceptors.response.use(
  response => {
    responseInterceptors(response.config)
    return response
  },
  error => {
    responseInterceptors(error.config)
    return Promise.reject('serve error')
  }
)
export default axios


// WEBPACK FOOTER //
// ./src/utils/axios.js